import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 → flat canonical /hvac-marketing-colorado-springs
export const Route = createFileRoute("/hvac/colorado-springs")({
  beforeLoad: () => {
    throw redirect({ to: "/hvac-marketing-colorado-springs", statusCode: 301 });
  },
  component: () => null,
});
